import { defineStore } from 'pinia';
import { fetchFictionCategories, fetchNonFictionCategories } from '@/api/index';

export const useCategoriesStore = defineStore('categories', {
  state: () => ({
    fictionCategories: [],
    nonFictionCategories: [],
  }),

  actions: {
    async fetchCategories() {
      const [fictionRes, nonFictionRes] = await Promise.all([
        fetchFictionCategories(),
        fetchNonFictionCategories(),
      ]);
      this.fictionCategories = fictionRes.data;
      this.nonFictionCategories = nonFictionRes.data;
    },
  },
});
